module.exports = __webpack_public_path__ + "img/qiyejieshao_bg_banner.min.d3eaf658.jpg";